(function ($, window) {
    'use strict';

    window.AdminKit = window.AdminKit || {};

    window.AdminKit.sidebar = {
        init: function () {
            var status = localStorage.getItem('sidebar_status') || 'expanded';

            if (status === 'collapsed' && window.matchMedia('(min-width: 992px)').matches) {
                $('body').addClass('sidebar-collapsed');
            }

            $('.sidebar-toggle').on('click', function () {
                if (window.matchMedia('(max-width: 991.98px)').matches) {
                    $('body').toggleClass('mobile-sidebar-open');
                    return;
                }

                $('body').toggleClass('sidebar-collapsed');
                localStorage.setItem('sidebar_status', $('body').hasClass('sidebar-collapsed') ? 'collapsed' : 'expanded');
                $('.floating-submenu').remove();
            });

            $('[data-sidebar-close], .sidebar-backdrop').on('click', function () {
                $('body').removeClass('mobile-sidebar-open');
            });

            $('.sidebar').on('click', '.has-submenu', function () {
                if ($('body').hasClass('sidebar-collapsed') && window.matchMedia('(min-width: 992px)').matches) {
                    return;
                }

                $(this).closest('.menu-group').toggleClass('open').siblings('.menu-group').removeClass('open');
            });

            this.bindFloatingSubmenus();
            this.bindCollapsedTooltips();
        },

        bindCollapsedTooltips: function () {
            var $tooltip = $('<div class="sidebar-tooltip"></div>');
            $('body').append($tooltip);

            $('.sidebar').on('mouseenter', '.menu-item', function () {
                if (!$('body').hasClass('sidebar-collapsed') || window.matchMedia('(max-width: 991.98px)').matches) {
                    return;
                }

                var $item = $(this);
                var label = $item.data('tooltip') || $.trim($item.find('span').first().text());

                if (!label) {
                    return;
                }

                var offset = $item.offset();
                $tooltip.text(label).css({
                    left: $('.sidebar').outerWidth() + 14,
                    top: offset.top + ($item.outerHeight() / 2) - ($tooltip.outerHeight() / 2)
                });

                requestAnimationFrame(function () {
                    $tooltip.addClass('show');
                });
            });

            $('.sidebar').on('mouseleave', '.menu-item', function () {
                $tooltip.removeClass('show');
            });

            $('.sidebar-toggle').on('click', function () {
                $tooltip.removeClass('show');
            });
        },

        bindFloatingSubmenus: function () {
            var hideTimer;

            $('.sidebar .menu-group').on('mouseenter', function () {
                if (!$('body').hasClass('sidebar-collapsed') || window.matchMedia('(max-width: 991.98px)').matches) {
                    return;
                }

                clearTimeout(hideTimer);
                $('.floating-submenu').remove();

                var $group = $(this);
                var $links = $group.find('.submenu a').clone();

                if (!$links.length) {
                    return;
                }

                var offset = $group.offset();
                var $floating = $('<div class="floating-submenu"></div>').append($links);

                $('body').append($floating);

                $floating.css({
                    left: $('.sidebar').outerWidth() + 12,
                    top: Math.max(12, offset.top)
                });

                requestAnimationFrame(function () {
                    $floating.addClass('show');
                });
            });

            $('.sidebar .menu-group').on('mouseleave', function () {
                hideTimer = setTimeout(function () {
                    $('.floating-submenu').removeClass('show').delay(160).queue(function () {
                        $(this).remove();
                    });
                }, 120);
            });

            $(document).on('mouseenter', '.floating-submenu', function () {
                clearTimeout(hideTimer);
            });

            $(document).on('mouseleave', '.floating-submenu', function () {
                $(this).removeClass('show').delay(160).queue(function () {
                    $(this).remove();
                });
            });
        }
    };
})(jQuery, window);
